import axios from 'axios';
import React, { useEffect, useState } from 'react'
import './dataTable.css'
import csvDownload from 'json-to-csv-export'

const baseURL = localStorage.getItem('baseURL')

function DataTable({setIsLoggedIn}) {

    const [trows, setTrows] = useState([]);

    useEffect(()=>{
        axios.get(baseURL+"/bt/transport_data", {headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('authToken')
        }}).then((response)=>{
            const tbody = document.querySelector('.dataTable tbody');
            const data = response.data.data;

            // data.sort((a, b)=>{
            //     var key1 = parseInt(a.bilty);
            //     var key2 = parseInt(b.bilty);
            //     if (key1<key2) return 1;
            //     return -1;
            // })
            // data.forEach((e, idx)=>{
            //     var netWt = parseFloat(e['weight'])-parseFloat(e['bagwt'])
            //     var amount = parseFloat(e['rate'])*netWt;
            //     netWt = (Math.round(netWt*100)/100).toFixed(2);
            //     amount = (Math.round(amount*100)/100).toFixed(2);
            //     tbody.innerHTML += `<tr><td>${idx+1}</td><td data-bilty="${e['bilty']}">${e['bilty']}</td><td>${e['date']}</td><td>${e['veh']}</td><td>${e['place']}</td><td>${e['bags']}</td><td>${e['weight']}</td><td>${e['bagwt']}</td><td>${netWt}</td><td>${e['rate']}</td><td>${amount}</td><td class="dataTable_delete">DEL</td></tr>`;
            // })
            // const del = document.getElementsByClassName("dataTable_delete");
            // del.forEach(btn=>{
            //     // btn.addEventListener('click', handleDelete)
            //     console.log(btn)
            // })
            
            setTrows(data);
            console.log(trows);
        })
    }, [])

    const downloadData = (e)=>{
        axios.get(baseURL+'/bt/transport_data/last_bill', {
            headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('authToken')
        }}).then(response=>{
            if (response.status!=200){
                console.log(response);
                window.alert('You are not logged-in');
                setIsLoggedIn(false);
            } else {
                const last_entry_date = response.data.data["date"];
                console.log(last_entry_date)
                // download data for this date
                axios.get(baseURL+'/bt/transport_data/download', {headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem('authToken')
                }, params: {
                    "type": "transport",
                    "date": last_entry_date
                }}).then(response=>{
                    // Save and download as CSV
                    const download_data = response.data.data.map((item)=>{
                        delete(item._id);
                        return item
                    });
                    console.log("Downloaded Data",download_data)
                    const dataToConvert = {
                        data: download_data,
                        filename: `Driver Details (${last_entry_date})`,
                        delimiter: ',',
                        headers: ["Date", 'Bilty', "Truck No.", "Mobile", "Transporter"]
                    }
                    csvDownload(dataToConvert)
                }).catch(err=>console.log(err));
            }
        }).catch(err=>{
        console.log(err);
        window.alert('You are not logged-in');
        setIsLoggedIn(false);
    })
    }

  return (
    <section className="dataTable">
      <p>This is what we have so far</p>
      <div>
        <table>
          <thead>
            <tr>
              <th>Sr no.</th>
              <th>Bill No.</th>
              <th>Date</th>
              <th>Vehicle No.</th>
              <th>Place</th>
              <th>Bags</th>
              <th>Weight</th>
              <th>Bags Wt.</th>
              <th>Net Weight</th>
              <th>Rate</th>
              <th>Amount</th>
              <th>Del</th>
            </tr>
          </thead>
          <tbody>
            {trows.map((data, idx) => {
              var netWt = parseFloat(data.weight) - parseFloat(data.bagwt);
              var amount = parseFloat(data.rate) * netWt;
              netWt = (Math.round(netWt * 100) / 100).toFixed(2);
              amount = (Math.round(amount * 100) / 100).toFixed(2);
              return (
                <DataTableRow
                  key={idx + 1}
                  idx={idx}
                  bilty={data.bilty}
                  date={data.date}
                  veh={data.veh}
                  place={data.place}
                  bags={data.bags}
                  weight={data.weight}
                  bagwt={data.bagwt}
                  netWt={netWt}
                  rate={data.rate}
                  amount={amount}
                />
              );
            })}
          </tbody>
        </table>
        <div onClick={downloadData} className="dataTable_download">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon icon-tabler icon-tabler-arrow-bar-down"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="white"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <line x1="12" y1="20" x2="12" y2="10"></line>
            <line x1="12" y1="20" x2="16" y2="16"></line>
            <line x1="12" y1="20" x2="8" y2="16"></line>
            <line x1="4" y1="4" x2="20" y2="4"></line>
          </svg>
        </div>
      </div>
    </section>
  );
}

function DataTableRow(props) {

    const handleDelete = (e)=>{
        const bilty = (e.target.parentNode.querySelector('[data-bilty]').innerHTML);
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('authToken')
        }
        if (window.confirm(`Do you really want to delete Bilty no.: ${bilty}?`)){
            axios.delete(baseURL+'/bt/transport_data/bilty', {headers: headers, data: {bilty: bilty}}).then(response=>{
                const deleteCount = parseInt(response.data.data.deletedCount);
                if (deleteCount!=0){
                    e.target.parentNode.remove();
                }
                window.alert("Data deleted")
            }).catch(err=>console.log(err))
        } else {
            window.alert("The data was not deleted")
        }
    }

  return (
    <tr key={props.key}>
      <td>{props.idx + 1}</td>
      <td data-bilty={props.bilty}>{props.bilty}</td>
      <td>{props.date}</td>
      <td>{props.veh}</td>
      <td>{props.place}</td>
      <td>{props.bags}</td>
      <td>{props.weight}</td>
      <td>{props.bagwt}</td>
      <td>{props.netWt}</td>
      <td>{props.rate}</td>
      <td>{props.amount}</td>
      <td onClick={handleDelete} class="dataTable_delete">DEL</td>
    </tr>
  );
}

export default DataTable